import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import A11ySvg from 'components/A11ySvg';
import SafeMarkdown from 'components/SafeMarkdown';
import TextButton from 'components/TextButton';
import BattleChallengeLogo from 'resources/BattleChallengeLogo.png';
import { ReactComponent as ModalExitIcon } from 'resources/cross.svg';
import { POKE_BADGES, iconLookupByType } from './utils';
import './WStoreBattleSlotsInventoryModal.css';

class BattleSlotsInventory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      info: false
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleBuyMore = this.handleBuyMore.bind(this);
    this.handleInfo = this.handleInfo.bind(this);
    this.handleCloseInfo = this.handleCloseInfo.bind(this);
  }

  handleClose() {
    this.props.onClose();
  }

  handleInfo() {
    this.setState({
      info: true
    });
  }

  handleCloseInfo() {
    this.setState({
      info: false
    });
  }

  handleBuyMore() {
    this.props.onBuyMore(this.props.battleSlotsCategory[0]);
    this.props.onClose();
  }

  renderBadges() {
    // const badges = getPokeIcons(
    //   lookupBattleInventoryByType(this.props.inventory, POKE_TYPE.UNLOCKED)
    //     .count
    // );
    const badges = POKE_BADGES;
    const pokeBadges = badges.map((badge, index) => {
      let badgeClass = 'poke-badge';
      return (
        <div className={badgeClass} key={index}>
          <img src={badge.image} alt={badge.badgeName} />
        </div>
      );
    });

    return (
      <React.Fragment>
        <div className="pokes-text">3 Power-Ups Per Battle</div>
        <div className="battle-slots-badges">{pokeBadges}</div>
      </React.Fragment>
    );
  }

  renderBadgeInfo() {
    const { inventory } = this.props;
    const filteredBadges = inventory.filter(
      badge =>
        badge.subCategory === 'Mud Power Up' ||
        badge.subCategory === 'Freeze Power Up' ||
        badge.subCategory === 'Shield Power Up'
    );
    const badges = filteredBadges.map(obj => ({
      ...obj,
      image: iconLookupByType(obj.subCategory)
    }));
    const badgesCount = badges;

    const badgesInformation = badgesCount.map((powerUp, index) => {
      return (
        <div className="power-up-wrapper" key={index}>
          <div className="power-up-value">{powerUp.count}</div>
          <div className="power-up-img">
            <img src={powerUp.image} alt={powerUp.subCategory} />
          </div>
        </div>
      );
    });
    return <div className={'battle-slots-power-ups'}>{badgesInformation}</div>;
  }

  renderButtons() {
    return (
      <div className="battle-slots-btns">
        <div className="battle-slots-info">
          <Button variant="info" bsSize="large" onClick={this.handleInfo}>
            Info
          </Button>
        </div>
        <div className="battle-slots-buy">
          <Button variant="success" bsSize="large" onClick={this.handleBuyMore}>
            Buy More
          </Button>
        </div>
      </div>
    );
  }

  renderExitIcon() {
    const { info } = this.state;
    return (
      <TextButton
        className={'battle-slots-modal-exit-icon'}
        onClick={info ? this.handleCloseInfo : this.handleClose}
      >
        <A11ySvg component={ModalExitIcon} alt="Close" />
      </TextButton>
    );
  }

  renderInformation() {
    const { battleSlotsInfoText } = this.props;
    return (
      <div className="battle-slots-information-text">
        <div className="info-text-transparent-background" />
        <SafeMarkdown>{battleSlotsInfoText}</SafeMarkdown>
      </div>
    );
  }

  renderBattleSlotsSummary() {
    return (
      <div>
        <div className={'battle-slots-badges-container'}>
          {this.renderBadges()}
        </div>
        <div className={'battle-slots-power-ups-container'}>
          {this.renderBadgeInfo()}
        </div>
        <div className={'battle-slots-btns-container'}>
          {this.renderButtons()}
        </div>
      </div>
    );
  }

  render() {
    const { show } = this.props;
    const { info } = this.state;
    const className = 'modal-dialog-wstore-battle-slots-inventory';

    return (
      <Modal className={className} onHide={this.handleClose} show={show}>
        <Modal.Body>
          <div className={'battle-slots-logo-container'}>
            <div className="battle-slots-logo">
              <img src={BattleChallengeLogo} alt="Battle Challenge Logo" />
            </div>
          </div>
          {info ? this.renderInformation() : this.renderBattleSlotsSummary()}
          {this.renderExitIcon()}
        </Modal.Body>
      </Modal>
    );
  }
}

BattleSlotsInventory.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
  inventory: PropTypes.arrayOf(
    PropTypes.shape({
      subCategory: PropTypes.string,
      count: PropTypes.number
    })
  )
};

export default BattleSlotsInventory;
